<template>
  <div class="swiper">
    <swiper
      :options="swiperOption"
      class="swiper-container"
      ref="bannerSwiper"
      @someSwiperEvent="callback"
    >
      <!-- 轮播图组-新 (xunxiang特殊处理) -->
      <template v-if="['xunxiang'].includes(currentHost)">
        <swiper-slide v-for="(image, index) in swiperImages" :key="index">
          <img :src="image" alt="Image" />
        </swiper-slide>
      </template>

      <!-- 动态轮播图 -->
      <swiper-slide v-for="slide in currentBannerSlides" :key="slide.id">
        <a href="javascript:;">
          <!-- 产品类型轮播图 -->
          <div v-if="slide.type === 'product'" class="banner-bg">
            <div class="banner-content">
              <div class="banner-text">
                <h3 class="banner-title" v-html="slide.title"></h3>
                <p class="banner-intro" v-html="slide.intro"></p>
                <p class="brief-explain m-top" v-html="slide.explain"></p>
                <div>
                  <!-- <button class="more-btn font-w600">了解更多</button> -->
                </div>
              </div>
              <div class="banner-product">
                <img :src="getProductImagePath(slide.image)" :alt="slide.title" />
              </div>
            </div>
          </div>
          
          <!-- 品牌类型轮播图 -->
          <div v-else-if="slide.type === 'brand'" 
               class="banner-bg-brand"
               :style="getBrandBackgroundStyle(slide.backgroundImage)">
          </div>
        </a>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination">
      <!-- <div class="page"></div> -->
    </div>
    <!-- 分页 -->
  </div>
</template>

<script>
import { bannerMixin } from "@/mixins/bannerMixin.js";

export default {
  name: "carrousel",
  mixins: [bannerMixin],
  methods: {
    callback() {}
  }
};
</script>

<style></style>
